<div *ngIf="selection != id">
    <ng-content></ng-content>
</div>